<script>
  // import { 
    // am_criticalFacilitiesLayersStore, 
    // am_conceptualBWSCProjectsLayersStore, 
    // am_climateReadyBostonLayersStore 
  // } from './stores_adaptation_measures.js';
  
  // the <ToggleAMLayers> component:
  // - allows users to toggle AM View layers
  // - displays an icon w/popup for screen widths 820px and smaller
  // - larger displays do not show a popup

  export let adaptationMeasuresWidgetContainerCSS;
  export let criticalFacilitiesWidgetContainer;
  export let criticalFacilitiesWidgetValueCSS;
  export let handleCriticalFacilitiesLayerFiltering;
  export let am_criticalFacilitiesLayersStore;
  export let am_climateReadyBostonLayersStore;
  export let am_conceptualBWSCProjectsLayersStore;

</script>


<div class="adaptation-measures-widget-container" style="display: {adaptationMeasuresWidgetContainerCSS}" id="adaptation-measures-widget-container">
  <span class="critical-facilities-widget-container" style="display: {criticalFacilitiesWidgetValueCSS}" id="critical-facilities-measures-widget-container" bind:this={criticalFacilitiesWidgetContainer}>
    <!-- only show the critical facilities layer control UI contents if there are layers to control -->
    <!-- svelte-ignore a11y-label-has-associated-control -->
      <label style="cursor: pointer; display: flex; align-items: center; margin: 0 8px; min-width: 160px;">
        <calcite-switch
          scale="s"
          theme="light"
          checked="{$am_criticalFacilitiesLayersStore.visible}"
          on:calciteSwitchChange="{(e) => {
            $am_criticalFacilitiesLayersStore.visible = !$am_criticalFacilitiesLayersStore.visible;
            $am_criticalFacilitiesLayersStore.layers.forEach((layer) => {
              layer.visible = $am_criticalFacilitiesLayersStore.visible
            });
          }}"
        >
        </calcite-switch>
        <span style="margin-left: 5px;">
          Critical Facilities
        </span>
      </label>
  
      <!-- 2. the dropdown component is used to toggle filterEffects on critical facilities layerview(s) -->
      <calcite-dropdown
        placement="end"
        close-on-select-disabled="true"
        on:calciteDropdownSelect="{(e) => { handleCriticalFacilitiesLayerFiltering(e.target.selectedItems) }}"
      >
        <calcite-button
          slot="trigger"
          scale="s"
          icon-start="caretDown"
        >
        </calcite-button>
        <calcite-dropdown-group selection-mode="multiple">
          <calcite-dropdown-item
            selected="{$am_criticalFacilitiesLayersStore.visuallyFilteredCategories['School']}"
          >
            School
          </calcite-dropdown-item>
          <calcite-dropdown-item
            selected="{$am_criticalFacilitiesLayersStore.visuallyFilteredCategories['Health Facility']}"
          >
            Health Facility
          </calcite-dropdown-item>
          <calcite-dropdown-item
            selected="{$am_criticalFacilitiesLayersStore.visuallyFilteredCategories['Police Department']}"
          >
            Police Department
          </calcite-dropdown-item>
          <calcite-dropdown-item
            selected="{$am_criticalFacilitiesLayersStore.visuallyFilteredCategories['EMS/Fire Station']}"
          >
            EMS/Fire Station
          </calcite-dropdown-item>
          <calcite-dropdown-item
            selected="{$am_criticalFacilitiesLayersStore.visuallyFilteredCategories['MBTA Station']}"
          >
            MBTA Station
          </calcite-dropdown-item>
        </calcite-dropdown-group>
      </calcite-dropdown>
    <!-- {/if} -->
  </span>
    <!-- svelte-ignore a11y-label-has-associated-control -->
    <label style="cursor: pointer; display: flex; align-items: center; margin: 0 8px; min-width: 160px;">
      <calcite-switch
        scale="s"
        theme="light"
        checked="{$am_conceptualBWSCProjectsLayersStore.visible}"
        on:calciteSwitchChange="{(e) => {
          $am_conceptualBWSCProjectsLayersStore.visible = !$am_conceptualBWSCProjectsLayersStore.visible;
          $am_conceptualBWSCProjectsLayersStore.layers.forEach((layer) => {
            layer.visible = $am_conceptualBWSCProjectsLayersStore.visible
          });
        }}"
      >
      </calcite-switch>
      <span style="margin-left: 5px;">
        Conceptual BWSC Projects
      </span>
    </label>

    <!-- svelte-ignore a11y-label-has-associated-control -->
    <label style="cursor: pointer; display: flex; align-items: center; margin: 2px 8px; min-width: 160px;">
      <calcite-switch
        scale="s"
        theme="light"
        checked="{$am_climateReadyBostonLayersStore.visible}"
        on:calciteSwitchChange="{(e) => {
          $am_climateReadyBostonLayersStore.visible = !$am_climateReadyBostonLayersStore.visible;
          $am_climateReadyBostonLayersStore.layers.forEach((layer) => {
            layer.visible = $am_climateReadyBostonLayersStore.visible
          });
        }}"
      >
      </calcite-switch>
      <span style="margin-left: 5px;">
        Climate Ready Boston
      </span>
    </label>
</div>

<style>
  .adaptation-measures-widget-container {
    background-color: rgb(255, 255, 255);
    color: #323232;
    align-items: center;
    border: black;
    border-width: thin;
    border-style: solid;
    width: 200px;
  }

  .critical-facilities-widget-container {
    background-color: rgb(255, 255, 255);
    color: #323232;
    align-items: center;
  }
</style>
